import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { EaLiteLimiterSchema } from "../ea.schema";

const base = "eaLiteLimiter";
const eaLiteLimiter = createEndpointBase(base);

export const eaLiteLimiterEndpoints = {
  eaLiteLimiter: eaLiteLimiter({
    method: "GET",
    path: "",
    request: z.looseObject({}),
    response: EaLiteLimiterSchema,
    description: "Retrieves the EA Lite limiter limits.",
  }),
} as const;
